import yup, { cardNameValidator, stringValidator, imageValidator } from '~/utils/validators.yup';

export const schema = (nullable = false, maxSize = null) =>
    yup.object({
        name: cardNameValidator(),
        rarity: stringValidator.required(),
        size: stringValidator.required(),
        image: imageValidator(nullable, maxSize),
    });
